import { __spreadArray } from "tslib";
import color from 'color';
/**
 * Micro function: Linear Shade - Version 4.0 - 02/18/2019
 * https://github.com/PimpTrizkit/PJs/wiki/12.-Shade,-Blend-and-Convert-a-Web-Color-(pSBC.js)
 * #micro-functions-version-4
 *
 * This will take a RGB web color. It can shade it darker or lighter
 * @param p <Percentage Float> *REQUIRED
 * Used, as a percentage, with typical range of -1.0 to 1.0.
 * Out of range parameter will cause a return of null.
 * @param b <string> Color in RGB format
*/

export var linearShade = function linearShade(p, c) {
  var _a = c.split(','),
      rawR = _a[0],
      g = _a[1],
      b = _a[2],
      a = _a[3],
      //Getting first rgb/a value
  r = rawR[3] === 'a' ? rawR.slice(5) : rawR.slice(4),
      isNegative = p < 0,
      //Define if it is black or white to tint or shade
  round = Math.round,
      int = parseInt,
      //Remove string chars and convert in a int
  //I still don't know what this means and the wiki doesn't specify it:
  t = isNegative ? 0 : 255 * p,
      P = isNegative ? 1 + p : 1 - p;

  var R = round(int(r) * P + t),
      G = round(int(g) * P + t),
      B = round(int(b) * P + t);
  return 'rgb' + (a ? 'a(' : '(') //if is alpha then add alpha value otherwise start.
  + R + ',' + G + ',' + B + (a ? ',' + a : ')') //if is alpha then add alpha value otherwise finish.
  ;
};
export var defaultTintPercentages = [95, 80, 60, 40, 20];
export var defaultShadePercentages = [20, 40, 50, 60, 70];
export var defaultGrayShadesPercentages = [100, 95, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0];

var mapColorSequence = function mapColorSequence(baseColor, percentages, getTints) {
  return function (_, index) {
    var colorAmount = percentages[index] / 100;
    return linearShade(getTints ? colorAmount : -colorAmount, baseColor);
  };
};

var getPercentages = function getPercentages(percentages, accessor, defaultPercentages) {
  if (!percentages) return defaultPercentages;

  if (!Array.isArray(percentages)) {
    return (percentages === null || percentages === void 0 ? void 0 : percentages[accessor]) || defaultPercentages;
  }

  return percentages || defaultPercentages;
};

export var generateColorScales = function generateColorScales(baseColor, scaleSize, percentages, grayScale) {
  //Initializers
  var model = new Array(scaleSize || 5).fill(null); //Options

  var rgbColor = color(baseColor).rgb().string(),
      getTints = true,
      tintPercentages = getPercentages(percentages, 'tint', defaultTintPercentages),
      shadesPercentages = getPercentages(percentages, 'shade', defaultShadePercentages);
  var tints = model.map(mapColorSequence(rgbColor, tintPercentages, getTints)),
      shades = model.map(mapColorSequence(rgbColor, shadesPercentages));
  var scales = grayScale ? __spreadArray(__spreadArray([], tints, true), ['#000'], false) : __spreadArray(__spreadArray(__spreadArray([], tints, true), [baseColor], false), shades, true);
  return scales;
};
export function lighten(c, amount) {
  return color(c).lighten(amount).hsl().string();
}
export function alpha(c, amount) {
  return color(c).alpha(amount).hsl().string();
}
/**
 *
 * Redesign Color Scales  24/11/2021
 * https://www.figma.com/file/rjw1RbI8HFrNEmb3xaB49G/ION-Design-System?node-id=5576%3A21582
 *
 */

export var redesignScales = {
  green: ['#EDFDF5', '#C8F9E1', '#A3F5CD', '#7EF1BA', '#5ADEA6', '#17CF77', '#14B869', '#109354', '#0C6E3F', '#095330', '#073E24'
  /* green1000 */
  ],
  blue: ['#F6F6FF', '#E3E3FF', '#C2C2FF', '#9999FF', '#7070FF', '#4B4BFF', '#3333FF', '#1F1FFF', '#0000F5', '#0000CC', '#0000A3'
  /* blue1000 */
  ],
  lightBlue: ['#F5FCFF', '#D6F4FF', '#ADE9FF', '#85DEFF', '#5CD3FF', '#32C8FF', '#3BCBFF', '#00B4F5', '#0096CC', '#0078A3', '#004B66'
  /* light-blue1000 */
  ],
  purple: ['#F6EFF8', '#E6D0F0', '#CCA2E2', '#BC83D8', '#AB64CE', '#A050C8', '#9A45C4', '#8436AB', '#6C2C8C', '#54226D', '#3C184B'
  /* purple1000 */
  ],
  red: ['#FFEFEB', '#FFCEC2', '#FFAD99', '#FF8D70', '#FF6C47', '#FF5A31', '#FF3B0A', '#E02D00', '#B82500', '#8F1D00', '#661400'
  /* red1000 */
  ],
  pink: ['#FEFAFB', '#FBEEF1', '#F8DDE3', '#F4CDD4', '#F1BCC6', '#EBA2B1', '#E6899C', '#DF687F', '#DB5771', '#D84663', '#CA2B4B'
  /* pink1000 */
  ],
  yellow: ['#FEFDF6', '#FAF6DB', '#F6EDB7', '#F1E493', '#ECDB6F', '#E9D453', '#E5CE38', '#D9C01C', '#C7B01A', '#B5A017', '#A29015'
  /* yellow1000 */
  ],
  gray: ['#FCFCFC', '#F1F2F2', '#E4E4E4', '#D6D7D7', '#C9C9C9', '#BBBCBC', '#969696', '#707171', '#5E5E5E', '#4B4B4B', '#383838'
  /* gray1000 */
  ]
};